
let docUrl = 'https://t423iymvt2.execute-api.ap-south-1.amazonaws.com/production/';
let hubUrl = 'https://rqkrv4gewh.execute-api.ap-south-1.amazonaws.com/production/'; 
let razorpayKeyId = 'rzp_live_UWce9Kf91IjEFC'; 
let razorpayCompanyName = 'Hoppysoft Private Limited';
let logUrl = docUrl;

export { razorpayKeyId, razorpayCompanyName, hubUrl, docUrl, logUrl }